// components/Chat/LoadingMessage.js
import React, { useState, useEffect } from 'react';

// Sequential (not random) so the status reads as a coherent progression
// through the actual retrieval -> generation pipeline, rather than a
// randomly jumping placeholder.
const LOADING_MESSAGES = [
    'Reading your question',
    'Searching NHS trust documents',
    'Reviewing relevant sources',
    'Synthesizing the findings',
    'Structuring the response',
    'Preparing the answer'
];

const LoadingMessage = () => {
    const [messageIndex, setMessageIndex] = useState(0);
    const [visible, setVisible] = useState(true);

    const styles = {
        container: {
            display: 'flex',
            alignItems: 'center',
            padding: '2px 0',
            margin: '4px 0'
        },
        dot: {
            width: '7px',
            height: '7px',
            borderRadius: '50%',
            backgroundColor: '#3572EF',
            flexShrink: 0,
            animation: 'loading-dot-pulse 1.4s ease-in-out infinite'
        },
        text: {
            fontSize: '0.875rem',
            color: '#6c757d',
            marginLeft: '10px',
            transition: 'opacity 0.35s ease-in-out',
            opacity: visible ? 1 : 0
        }
    };

    useEffect(() => {
        if (!document.querySelector('#loading-keyframes')) {
            const style = document.createElement('style');
            style.id = 'loading-keyframes';
            style.textContent = `
                @keyframes loading-dot-pulse {
                    0%, 100% { opacity: 0.35; transform: scale(0.85); }
                    50% { opacity: 1; transform: scale(1); }
                }
            `;
            document.head.appendChild(style);
        }

        const cycleInterval = setInterval(() => {
            setVisible(false);
            setTimeout(() => {
                setMessageIndex(prev => (prev + 1) % LOADING_MESSAGES.length);
                setVisible(true);
            }, 350);
        }, 2600);

        return () => clearInterval(cycleInterval);
    }, []);

    return (
        <div style={styles.container}>
            <div style={styles.dot} />
            <span style={styles.text}>
                {LOADING_MESSAGES[messageIndex]}&hellip;
            </span>
        </div>
    );
};

export default LoadingMessage;
